import * as React from "react";
import { useCallback } from "react";
import { useFormikContext, FieldArray } from "formik";
import MetricConfiguration from "./MetricConfiguration";
import MetricElement from "./MetricElement";
import ElementConfigurationContainer from "../ElementConfigurationContainer";
const MetricsConfiguration = () => {
  const {
    values: { metrics },
    setValues,
    values
  } = useFormikContext();
  const removeMetric = useCallback(
    (index) => () => {
      setValues(MetricElement.onRemove(index, values));
    },
    [setValues, values]
  );
  return /* @__PURE__ */ React.createElement(
    FieldArray,
    {
      name: "metrics",
      validateOnChange: false,
      render: () => /* @__PURE__ */ React.createElement(React.Fragment, null, metrics.map((_metric, index) => /* @__PURE__ */ React.createElement(
        ElementConfigurationContainer,
        {
          key: `metrics-${index}`,
          onRemove: removeMetric(index),
          elementTitle: MetricElement.title
        },
        /* @__PURE__ */ React.createElement(MetricConfiguration, { index })
      )))
    }
  );
};
export default MetricsConfiguration;
